import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faUser, faHandsClapping, faBookmark } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons'
import blogImage from '../../img/element_Used.png';
import logo from '../../img/logo.png';
import unstoppable from '../../img/unstoppables.png';

const Blog = () => {
    return (
        <div className='px-4 md:px-12 py-6'>
            <div className=' md:flex md:flex-row-reverse mb-10'>
                <div className='flex-1 flex justify-center'>
                    <img src={blogImage} alt="" />
                </div>
                <div className='flex-1'>
                    <h1 className='text-2xl md:text-4xl font-semibold text-left mt-4 '>Receive fundamental direction and mentoring to help you on your personal success journey.</h1>
                </div>
            </div>
            <div className='md:flex '>
                <div className='flex-1'>
                    <div className='flex align-middle mb-2'>
                        <img className='h-14' src={logo} alt="logo" />
                        <h2 className='font-semibold text-2xl'><span className='text-blue-400'>Career</span> <span className='text-orange-400'>Hikers</span> Blog</h2>
                    </div>
                    <p className=''>Career Hikers is a community of top industry experts that provides academic counseling and a complete career path. The blog is for stories about our culture, engineering, product, company news and much more.</p>
                    <h4 className='mt-6 text-slate-500 text-xl mb-3'>ELSEWHERE</h4>
                    <FontAwesomeIcon className='text-3xl mr-4 text-red-500 hover:cursor-pointer' icon={faEnvelope}></FontAwesomeIcon>
                    <FontAwesomeIcon className='text-3xl mr-4 text-blue-400 hover:cursor-pointer' icon={faTwitter}></FontAwesomeIcon>
                    <FontAwesomeIcon className='text-3xl mr-4 text-blue-600 hover:cursor-pointer' icon={faFacebook}></FontAwesomeIcon>
                    <h4 className='mt-6 text-slate-500 text-xl'>MORE, ON MEDIUM</h4>
                    <button className='border py-1 px-4 rounded-md mt-4'>News</button>
                </div>
                <div className='flex-1'>
                    <div className='border shadow-md px-2 py-4'>
                        <div className='flex'>
                            <FontAwesomeIcon className='text-3xl mr-4 text-blue-600 hover:cursor-pointer border p-1' icon={faUser} ></FontAwesomeIcon>
                            <div>
                                <h4 className='text-green-500 text-xl'>Shakib Al Hasan in Career Hikers Blog</h4>
                                <p className='text-xs mt-0'>sep 4, 2022. few days ago </p>
                            </div>
                        </div>
                        <div>
                            <img src={unstoppable} className='w-full my-2 rounded' alt="" />
                        </div>
                        <div>
                            <h2 className='text-2xl mb-2 font-semibold'>Career Hikers Learners Crack IBPS PO & Clerk Exams With Flying Colours</h2>
                            <p className='text-xs hover:cursor-pointer'>Read more...</p>
                        </div>
                        <div className='flex justify-between mt-4'>
                            <h4 className='text-xl'><FontAwesomeIcon icon={faHandsClapping} className='mr-2 text-green-600 hover:cursor-pointer' /> 6</h4>
                            <FontAwesomeIcon icon={faBookmark} className='mr-4 text-xl text-blue-600 hover:cursor-pointer' />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Blog;